import { getDocumentTypeData } from '@capsicum/common';
import { useCallback, useEffect, useState } from 'react';

import { BaseSelectInput, type BaseSelectInputProps } from '../select-input/BaseSelectInput';

type DocumentType = {
	id: number;
	name: string;
};

export type BaseDocumentSelectInputProps = Omit<
	BaseSelectInputProps<DocumentType>,
	'data' | 'itemTemplate' | 'onSearch'
> & {
	documentTypeProp: Array<string>;
	withoutInitialValue?: boolean;
};

export const BaseDocumentSelect = ({ documentTypeProp, onChange, value, ...props }: BaseDocumentSelectInputProps) => {
	const documentType = getDocumentTypeData(documentTypeProp);
	const documentObject = documentType?.find(item => item.id === value?.id);

	const [selectedItem, setSelectedItem] = useState<DocumentType | undefined>();

	useEffect(() => {
		if (!value) {
			setSelectedItem(undefined);
		} else {
			setSelectedItem(documentObject);
		}
	}, [value]);

	const documentItemTemplate = useCallback(({ item }: { item: DocumentType }) => {
		return item.name;
	}, []);

	const onSearch = useCallback((data: Array<DocumentType>, text: string) => {
		return data.filter(({ name }) => name?.toLowerCase().includes(text.toLowerCase()));
	}, []);

	return (
		<BaseSelectInput
			data={documentType}
			itemTemplate={documentItemTemplate}
			labelProp="name"
			value={selectedItem}
			onChange={onChange}
			onSearch={onSearch}
			{...props}
		/>
	);
};
